// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getProductos as listProductosAPI,
    getProducto as getProductoAPI,
    syncProductos as syncProductosAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { productosApiResponseError, productosApiResponseSuccess } from './actions';
import { ProductosActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getProducto({ payload: { id } }) {
    try {
        const response = yield call(getProductoAPI, id );
        const producto = response.data.data;
        // NOTE - You can change this according to response format from your api
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(productosApiResponseSuccess(ProductosActionTypes.GET_PRODUCTO, producto));
    } catch (error) {
        yield put(productosApiResponseError(ProductosActionTypes.GET_PRODUCTO, error));
        // api.setLoggedInUser(null);
        // setAuthorization(null);
    }
}

/**
 * List contactos
 */
function* listProductos() {
    try {
        const response = yield call(listProductosAPI);
        const listaProductos = response.data.data.productos;
        yield put(productosApiResponseSuccess(ProductosActionTypes.LIST_PRODUCTOS, listaProductos));
    } catch (error) {
        yield put(productosApiResponseError(ProductosActionTypes.LIST_PRODUCTOS, error));
    }
}

function* sincronizarProductos(){
    try{
        const response = yield call(syncProductosAPI)
        const resp = response.data
        yield put(productosApiResponseSuccess(ProductosActionTypes.SYNC_PRODUCTOS,resp))
    } catch(error){
        yield put(productosApiResponseError(ProductosActionTypes.SYNC_PRODUCTOS,error))
    }
}


export function* watchGetProducto(): any {
    yield takeEvery(ProductosActionTypes.GET_PRODUCTO, getProducto);
}

export function* watchListProductos(): any {
    yield takeEvery(ProductosActionTypes.LIST_PRODUCTOS, listProductos);
}
export function* watchSyncProductos(): any{
    yield takeEvery(ProductosActionTypes.SYNC_PRODUCTOS,sincronizarProductos)
}


function* productosSaga(): any {
    yield all([
        fork(watchGetProducto),
        fork(watchListProductos),
        fork(watchSyncProductos)
    ]);
}

export default productosSaga;
